var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapmoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1123 0V25.3801C74.2723 28.0801 82.9923 36.9601 85.4323 48.2001H109.812V0H63.1323H63.1123Z",
    fill: "#A2C617"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3892 61.0826C82.4092 74.5826 70.4091 84.6827 56.0091 84.6827C39.3891 84.6827 25.909 71.2026 25.909 54.5826C25.909 40.4826 35.6291 28.6826 48.7091 25.4225V0.0625C20.229 1.2225 0.729004 26.2825 0.729004 54.4826C0.729004 55.2826 0.729004 109.283 0.729004 109.283H1.32901H55.4491C83.9091 109.283 109.589 89.9427 109.769 61.0826H85.3692H85.3892Z",
    fill: "#253232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapmoLogo);
export default __webpack_public_path__ + "static/media/capmo_logo.b1081385bdf496ec18609c8e5e3cd6ac.svg";
export { ForwardRef as ReactComponent };